import React from "react"
import doenerCase from "scripts/doenerCase"
import { ArticleContentComponentContainer } from "../utils"

export const HeadingThree = ({ content }) => {
  const heading_anchor = doenerCase(content)

  return (
    <ArticleContentComponentContainer>
      <h4 className="title is-5 mt-5 mb-0" id={heading_anchor}>
        {content}
      </h4>
    </ArticleContentComponentContainer>
  )
}
